import { render, staticRenderFns } from "./form-item-file-input.vue?vue&type=template&id=6caba2f4&scoped=true"
import script from "./form-item-file-input.vue?vue&type=script&lang=js"
export * from "./form-item-file-input.vue?vue&type=script&lang=js"
import style0 from "./form-item-file-input.vue?vue&type=style&index=0&id=6caba2f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6caba2f4",
  null
  
)

export default component.exports